import React from 'react'

import Base from '../_Base'

const Home = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M18.627 10.245v9.374h-3.25v-4.312a1 1 0 0 0-1-1h-4.5a1 1 0 0 0-1 1v4.312H5.283v-9.374c0-.037-.017-.068-.02-.104L12 4.32l6.66 5.754c-.01.057-.035.109-.035.17m5.027 1.499-11-9.5a.998.998 0 0 0-1.306 0l-11 9.5a1 1 0 1 0 1.306 1.513l1.63-1.408v8.77a1 1 0 0 0 1 1h5.593a1 1 0 0 0 1-1v-4.312h2.5v4.312a1 1 0 0 0 1 1h5.25a1 1 0 0 0 1-1v-8.847l1.72 1.485a.998.998 0 0 0 1.41-.103 1 1 0 0 0-.102-1.41"
      fillRule="evenodd"
    />
  </Base>
)

export default Home
